var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { locationsUtils } from 'conversional-utils';
var initialState = {
    loading: false,
    getBranchesLoading: false,
    error: null,
    // Locations is branch services, not branches. We need to rename this later.
    locations: [],
    branches: [],
    selectedLocation: null,
    locationMeta: null
};
var locationsSlice = createSlice({
    name: 'locations',
    initialState: initialState,
    reducers: {
        selectLocation: function (state, action) {
            state.selectedLocation = action.payload;
        },
        getBranches: {
            reducer: function (state, action) {
                state.loading = true;
                state.error = null;
            },
            prepare: function (
            // These three are not used anymore. But to make sure we don't break the API, we keep them.
            closeTo, locationType, max_result, extraPayload) {
                return {
                    payload: extraPayload || {}
                };
            },
        },
        getBranchesSucceeded: function (state, action) {
            state.loading = false;
            // Exclude the branches without services
            var branchesWithServices = action.payload.filter(function (branch) { return branch.services && branch.services.length > 0; });
            state.branches = locationsUtils.sortLocations(branchesWithServices);
        },
        getBranchesFailed: function (state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        // This is for getting branch services. The name is misleading so we might need to change it later to fetchBranchServices.
        getLocations: {
            reducer: function (state, action) {
                state.loading = true;
                state.error = null;
            },
            prepare: function (closeTo, locationType, max_result, extraPayload) {
                return {
                    payload: __assign({ closeTo: closeTo, locationType: locationType, max_result: max_result }, (extraPayload || {})),
                };
            },
        },
        getLocationsSucceeded: function (state, action) {
            state.loading = false;
            state.locations = locationsUtils.sortLocations(action.payload);
        },
        getLocationsFailed: function (state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        getLocationMeta: {
            reducer: function (state, action) {
                state.loading = true;
                state.error = null;
            },
            prepare: function (action) {
                return {
                    payload: {
                        locationId: action.locationId,
                        key: action.key
                    },
                };
            }
        },
        getLocationMetaSucceeded: function (state, action) {
            state.loading = false;
            state.locationMeta = action.payload.meta;
        },
        getLocationMetaFailed: function (state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    },
});
export var 
// region Branches
getBranches = (_a = locationsSlice.actions, _a.getBranches), getBranchesSucceeded = _a.getBranchesSucceeded, getBranchesFailed = _a.getBranchesFailed, 
// endregion
// region Branch Services
getLocations = _a.getLocations, getLocationsSucceeded = _a.getLocationsSucceeded, getLocationsFailed = _a.getLocationsFailed, 
// endregion
selectLocation = _a.selectLocation, getLocationMeta = _a.getLocationMeta, getLocationMetaFailed = _a.getLocationMetaFailed, getLocationMetaSucceeded = _a.getLocationMetaSucceeded;
export default locationsSlice.reducer;
